import React, { Component } from "react";
import FlexView from "react-flexview";
import { v4 } from "uuid";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import Api from "../../../../Services/Api";
import { fetchDataAsync } from "../../../../Services/Utils";
import {
  ACTIVITY_TYPE,
  HttpStatus,
  INITIAL_DATE,
} from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";
import {
  initialDataAnalisa,
  initialDataKeterangan,
  initialDataPembawa,
  initialDataPemilik,
  initialDataTambahan,
  initialDataTransaksi,
  initialDataUnit,
} from "../config/formConfig";
import {
  ALERT_INFO_CONFIRMATION_TYPE,
  FAKTUR_JUAL_BENGKEL_KATEGORI,
} from "../constant";
import { getFjbDetail } from "../service";
import { constructPayloadSubmitNOS, validate } from "../utils";
import FakturJualBengkelDetailContent from "./fakturJualBengkelDetailContent";
import FakturJualBengkelHeader from "./fakturJualBengkelHeader";

class FakturJualBengkelDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        kodeCabang: this.props.kodeCabang,
        noFakturJualBengkel: v4(),
        tanggalFakturJualBengkel: INITIAL_DATE,
        kategoriFakturJualBengkel: FAKTUR_JUAL_BENGKEL_KATEGORI[0],
        noHotline: null,
        noBooking: null,
        noProspect: null,
        tipeFjb: null,
        noClaim: null,
        dataUnit: initialDataUnit,
        dataPemilik: initialDataPemilik,
        dataPembawa: initialDataPembawa,
        dataAnalisa: initialDataAnalisa,
        dataTransaksi: initialDataTransaksi,
        dataTambahan: initialDataTambahan,
        dataKeterangan: initialDataKeterangan,
      },
      listIdPelanggaran: [],
      alertInfo: {
        visible: false,
        title: null,
        content: null,
        type: ALERT_INFO_CONFIRMATION_TYPE.INFO,
        data: null,
      },
      activeTab: 0,
      scannerVisible: false,
      // untuk menangani case pelanggaran tab transaksi ketika berpindah tab dan kembali lagi
      // validasinya tidak terpanggil karena state ini ter reset
      pelanggaranJasa: {
        pelanggaranDiskonPercent: null,
        pelanggaranDiskon: null,
        pelanggaranHarga: null,
      },
      pelanggaranPartQr: {
        pelanggaranDiskonPercent: null,
        pelanggaranDiskon: null,
        pelanggaranHarga: null,
      },
      pelanggaranPartNonQR: {
        pelanggaranDiskonPercent: null,
        pelanggaranDiskon: null,
        pelanggaranHarga: null,
      },
      autoFilledCustomerData: {},
      autoFilledUnitData: {},
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevCabang = prevState.data?.kodeCabang?.value;
    const currCabang = this.state.data?.kodeCabang?.value;
    if (prevCabang !== currCabang) {
      this.setState((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          dataTransaksi: initialDataTransaksi,
        },
      }));
    }
  }

  loadData = async () => {
    const { user, tab, selectedData, setError, onTriggerLoading, kodeCabang } =
      this.props;
    const defaultAdminFjb = mapToObjectDDL(user.name, user.employeeId);
    this.handleSetSpesificData("dataTambahan", "adminFjb", defaultAdminFjb);
    if (selectedData) {
      onTriggerLoading();
      const result = await getFjbDetail({
        setError,
        selectedData,
        tab,
        kodeCabang,
        defaultAdminFjb,
      });
      onTriggerLoading();
      this.setState((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          ...result.data,
        },
        listIdPelanggaran: result?.data?.listIdPelanggaran || []
      }));
    }
  };

  fetchDataUnit = async () => {
    const { setError, selectedData } = this.props;
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailNosinFjb,
      menuName: "Faktur Jual Bengkel - NOS",
      setError,
      args: {
        nosin: selectedData?.nomorMesin,
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS && res.data.data) {
      return res;
    }

    const result = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getTabDataUnitNos,
      menuName: "Faktur Jual Bengkel - NOS",
      setError,
      args: {
        nosin: selectedData?.nomorFJB,
      },
    });
    if (
      result.ok &&
      result.data.status === HttpStatus.SUCCESS &&
      result.data.data
    ) {
      return result;
    }
  };

  fetchDataPemilik = async () => {
    const { setError, selectedData } = this.props;
    const resByNosin = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getUserProfileByNoSin,
      menuName: "Faktur Jual Bengkel - NOS",
      setError,
      args: {
        nosin: selectedData?.nomorMesin,
      },
    });
    if (
      resByNosin.ok &&
      resByNosin.data.status === HttpStatus.SUCCESS &&
      resByNosin.data.data
    ) {
      return resByNosin;
    }

    const result = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getTabDataPemilikNos,
      menuName: "Faktur Jual Bengkel - NOS",
      setError,
      args: {
        orderServicePartId: selectedData?.nomorFJB,
      },
    });
    if (
      result.ok &&
      result.data.status === HttpStatus.SUCCESS &&
      result.data.data
    ) {
      return result;
    }
  };

  setHeaderValue = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [name]: value,
      },
    }));
  };

  handleSetState = (callback) => {
    this.setState(callback);
  };

  handlePelanggaran = (conditionToAdd, approvalCode) => {
    this.setState((prev) => ({
      ...prev,
      listIdPelanggaran: conditionToAdd
        ? [...new Set([...(prev?.listIdPelanggaran || []), approvalCode])] || []
        : prev?.listIdPelanggaran?.filter((item) => item !== approvalCode) ||
          [],
    }));
  };

  handleAlertInfo = (title, content, type, data) => {
    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        visible: !prev.alertInfo.visible,
        title,
        content,
        type: type || ALERT_INFO_CONFIRMATION_TYPE.INFO,
        data,
      },
    }));
  };

  handleAcceptAlertInfo = () => {
    const { alertInfo } = this.state;

    switch (alertInfo.type) {
      case ALERT_INFO_CONFIRMATION_TYPE.INFO:
        this.handleAlertInfo();
        break;
      case ALERT_INFO_CONFIRMATION_TYPE.SUBMIT:
        this.handleAlertInfo();
        this.handleSubmitConfirmOrder();
        break;
      case ALERT_INFO_CONFIRMATION_TYPE.CLEAR_INPUT:
        this.handleAlertInfo();
        this.handleConfirmClear();
        break;
      default:
        break;
    }
  };

  handleSetSpesificData = (tab, name, value) => {
    this.setState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [tab]: {
          ...prev.data[tab],
          [name]: value,
        },
      },
    }));
  };

  validateDataTransaksi = () => {
    const { data } = this.state;
    const { dataTransaksi } = data;
    const part = dataTransaksi?.dataPartNonQR || [];
    const partQr = dataTransaksi?.dataPartQR || [];
    const jasa = dataTransaksi?.dataJob || [];

    const combinedDataPart = [...part, ...partQr];

    const isNotFillTable = jasa?.length === 0 && combinedDataPart?.length === 0;
    const isUnSavedExist =
      [...jasa, ...combinedDataPart].length > 0 &&
      [...jasa, ...combinedDataPart].some((item) => !item.isSaved);

    if (partQr.find((item) => !item.qrCode)) {
      this.handleAlertInfo(
        "Informasi",
        "Terdapat Data QR Yang Belum Diisi. Harap Periksa Kembali"
      );
      return false;
    }

    if (isUnSavedExist || isNotFillTable) {
      this.handleAlertInfo(
        "Informasi",
        "Terdapat Data Transaksi Yang Belum Diisi. Harap Periksa Kembali"
      );
      return false;
    }
    return true;
  };

  handleConfirmOrder = () => {
    this.handleAlertInfo(
      "Informasi",
      "Apakah anda yakin ingin menconfirm data ini?",
      ALERT_INFO_CONFIRMATION_TYPE.SUBMIT
    );
  };

  handleSubmitConfirmOrder = async () => {
    const { data } = this.state;
    const {
      onTriggerLoading,
      setError,
      onClickClose,
      onRefresh,
      tab,
      selectedData,
      onTriggerFjbAlert,
      activityType
    } = this.props;

    const req = constructPayloadSubmitNOS(data);
    // console.log(req)
    const err = validate(req, data?.fjbSource);
    const isValid = Object.values(err).every(
      (val) =>
        (typeof val === "object" && Object.keys(val).length === 0) || !val
    );

    if (!isValid) {
      console.log(err);
      this.handleAlertInfo(
        "Informasi",
        "Terdapat data yang belum lengkap, mohon periksa kembali"
      );

      this.setState({
        errors: err,
      });
      return;
    }
    const isValidTrx = this.validateDataTransaksi(req);
    if (!isValidTrx) {
      return;
    }

    req.source = data?.fjbSource === "STOCK_OPNAME" ? "STOCK_OPNAME" : tab;
    req.statusFakturJualBengkel =
      tab === "DGI" || !selectedData ? "DRAFT" : selectedData?.status;
      
    if (this.state.listIdPelanggaran.length > 0) {
      req.listPelanggaran = this.state.listIdPelanggaran;
      req.action = "CONFIRM_ORDER_WITH_VIOLATION";
    }

    // part ini bakal nge overide semua jenis action, jadi intinya kalo dia melengkapi 
    // statusnya bakal ini, meskipun ada pelanggaran, kalo dia melengkapi statusnya tetap ini
    if(activityType === ACTIVITY_TYPE.CORRECTION){
      req.action = "CONFIRM_ORDER_MELENGKAPI"
    }

    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").submitFjbNOS,
      menuName: "Faktur Jual Bengkel - NOS",
      setError: setError,
      args: req,
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      if (res.data?.data?.includes("Terjadi perubahan")) {
        onTriggerFjbAlert("Informasi", res.data.data);
      } else {
        onTriggerFjbAlert("Informasi", "Data Berhasil Disimpan");
      }
      onClickClose();
      onRefresh();
    }
    if (!res.ok) {
      this.handleAlertInfo("Informasi", res.data.message);
    }
  };

  handleClear = () => {
    this.handleAlertInfo(
      "Pertanyaan",
      "Semua data pada tab ini akan anda kosongkan? apakah anda yakin akan melakukanhal ini?",
      ALERT_INFO_CONFIRMATION_TYPE.CLEAR_INPUT
    );
  };

  handleConfirmClear = () => {
    const { activeTab } = this.state;
    let key = null;
    let data = null;

    switch (activeTab) {
      case 1:
        key = "dataPemilik";
        data = initialDataPemilik;
        break;
      case 2:
        key = "dataPembawa";
        data = initialDataPembawa;
        break;
      case 3:
        key = "dataAnalisa";
        data = initialDataAnalisa;
        break;
      case 4:
        key = "dataTransaksi";
        data = initialDataTransaksi;
        break;
      case 5:
        const { adminFjb, ...rest } = initialDataPembawa;
        key = "dataTambahan";
        data = rest;
        break;
      case 6:
        key = "dataKeterangan";
        data = initialDataKeterangan;
        break;

      default:
        key = "dataUnit";
        data = initialDataUnit;
        break;
    }
    this.setState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [key]: data,
      },
    }));
  };

  render() {
    const { tab, visible, onClickClose, activityType } = this.props;
    const { data, alertInfo, errors, listIdPelanggaran, pelanggaranJasa, pelanggaranPartQr, pelanggaranPartNonQR, autoFilledCustomerData, autoFilledUnitData } = this.state;

    const isReadOnly = activityType === ACTIVITY_TYPE.VIEW;
    const isSO = data?.fjbSource === "STOCK_OPNAME";
    const isDirectSales = data?.kategoriFakturJualBengkel?.value === "DIRECT_SALES";
    
    return (
      <SimpleModal
        styles={{ width: "90%" }}
        title={`Detail Faktur Jual Bengkel - ${tab}`}
        visible={visible}
        onClickClose={onClickClose}
        content={
          <React.Fragment>
            <ModalContainer>
              <FakturJualBengkelHeader
                {...this.props}
                formData={data}
                errors={errors}
                onSetState={this.handleSetState}
                onChangeData={this.setHeaderValue}
              />
              <FakturJualBengkelDetailContent
                {...this.props}
                formData={data}
                errors={errors}
                isSO={isSO}
                autoFilledCustomerData={autoFilledCustomerData}
                autoFilledUnitData={autoFilledUnitData}
                listIdPelanggaran={listIdPelanggaran}
                pelanggaranJasa={pelanggaranJasa} 
                pelanggaranPartQr={pelanggaranPartQr}
                pelanggaranPartNonQR={pelanggaranPartNonQR}
                handlePelanggaran={this.handlePelanggaran}
                isDirectSales={isDirectSales}
                onTriggerAlert={this.handleAlertInfo}
                onSetState={this.handleSetState}
                onSetSpesificData={this.handleSetSpesificData}
              />
              <FlexView hAlignContent="right" style={{ gap: "10px" }}>
                <SimpleButton
                  secondary={isReadOnly}
                  disabled={isReadOnly}
                  text="Clear"
                  onClick={this.handleClear}
                />
                <SimpleButton
                  secondary={isReadOnly}
                  disabled={isReadOnly}
                  text="Confirm Order"
                  onClick={() => this.handleConfirmOrder()}
                  icon={<i className="fa fa-check-circle margin-right-10px" />}
                  styles={{ width: "auto" }}
                />
              </FlexView>
            </ModalContainer>
            {alertInfo.visible && (
              <SimpleAlert
                title={alertInfo.title}
                content={alertInfo.content}
                onClickClose={this.handleAlertInfo}
                visible={alertInfo.visible}
                additionalButtons={
                  alertInfo.type === ALERT_INFO_CONFIRMATION_TYPE.INFO ? (
                    <SimpleButton
                      id="btn_ok_alert_info"
                      text="OK"
                      onClick={this.handleAlertInfo}
                    />
                  ) : (
                    <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                      <SimpleButton
                        id="btn_tidak_alert_info"
                        text="Tidak"
                        onClick={this.handleAlertInfo}
                      />
                      <SimpleButton
                        id="btn_ya_alert_info"
                        text="Ya"
                        onClick={this.handleAcceptAlertInfo}
                      />
                    </FlexView>
                  )
                }
              />
            )}
          </React.Fragment>
        }
      />
    );
  }
}

export default FakturJualBengkelDetail;
